import React from 'react';
import { useLoomTouchpointVariant } from '@atlassian/jira-loom-utils/src/controllers/use-loom-touchpoint-variant/index.tsx';
import { LoomTouchpointVariant } from '@atlassian/jira-loom-utils/src/controllers/use-loom-touchpoint-variant/types.tsx';
import { CoUseRecordItem } from './co-use/index.tsx';
import { CrossJoinRecordItem } from './cross-join/index.tsx';
import type { Props } from './types.tsx';

export const RecordNewLoomItem = ({ onInsertLink }: Props): React.JSX.Element | null => {
	const { loomTouchpointVariant } = useLoomTouchpointVariant();
	switch (loomTouchpointVariant) {
		case LoomTouchpointVariant.COUSE:
			return <CoUseRecordItem onInsertLink={onInsertLink} />;
		case LoomTouchpointVariant.CROSSJOIN:
			return <CrossJoinRecordItem />;
		default:
			return null;
	}
};
